import api from "../Service/Api";
import { toastr } from "react-redux-toastr";


const skillsBaseController = "api/skills";

//===============Api for Get All Skills without Pagination========================

export const getAllSkillSelect = async () => {
    if (navigator.onLine === false) {
      toastr.error('No Internet Connection', 'Please try again');
    } else {
      try {
        const response = await api.get(`${skillsBaseController}/get-all-skills-without-pagination`);
       /*  console.log(response) */
        if (typeof response !== "undefined") {
          if (response.status === 200) {
            // // toastr.success('Get All SkillSelect', 'Success')
            return response.data.data;
          }
          
          // console.log(response)
        } else {
          toastr.error("An Error occured", "Please try again")
        }
  
      } catch (ex) {
        toastr.error("An Error occured", "Please try again")
      }
    }
  }